<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h500_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="所属工业">
                    <el-input
                      v-model="dialogAddEditViewForm.industry"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="品牌">
                    <el-input
                      v-model="dialogAddEditViewForm.brand"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="品规"
                    prop="productId"
                  >
                    <el-select
                      v-if="eventType==='add'"
                      v-model="dialogAddEditViewForm.productId"
                      filterable
                      clearable
                      placeholder="请选择品规"
                      style="width:100%"
                      @change="changeProductFun"
                    >
                      <el-option
                        v-for="item in productOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.productName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="最小库存数量"
                    prop="minStorageAmount"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.minStorageAmount"
                      :min="0"
                      :step="1"
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最大库存数量"
                    prop="maxStorageAmount"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.maxStorageAmount"
                      :min="dialogAddEditViewForm.minStorageAmount"
                      :step="1"
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最小到货数量"
                    prop="minArrivalAmount"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.minArrivalAmount"
                      :min="0"
                      :step="1"
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最大到货数量"
                    prop="maxArrivalAmount"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.maxArrivalAmount"
                      :min="dialogAddEditViewForm.minArrivalAmount"
                      :step="1"
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最小本码出货价"
                    prop="minPrice"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.minPrice"
                      :min="0"
                      :precision="2"
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最大本码出货价"
                    prop="maxPrice"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.maxPrice"
                      :min="dialogAddEditViewForm.minPrice"
                      :precision="2"
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { listTobaccoInfoApi } from '@/api/v2/tobaccoInfo'
// 数据请求
import { initRetailMonitoringProductDataRangeApi, saveOrUpdateRetailMonitoringProductDataRangeApi } from '@/api/retailMonitoringProductDataRange'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        productId: [{ required: true, message: '请选项调查品规', trigger: 'change' }],
        minStorageAmount: [{ required: true, message: '请输入最小库存数量', trigger: 'blur' }],
        maxStorageAmount: [{ required: true, message: '请输入最大库存数量', trigger: 'blur' }],
        minArrivalAmount: [{ required: true, message: '请输入最小到货数量', trigger: 'blur' }],
        maxArrivalAmount: [{ required: true, message: '请输入最大到货数量', trigger: 'blur' }],
        minPrice: [{ required: true, message: '请输入最小本码出货价', trigger: 'blur' }],
        maxPrice: [{ required: true, message: '请输入最大本码出货价', trigger: 'blur' }],
        remark: [{ max: 500, message: '备注内容最多输入500个字符', trigger: 'blur' }]
      },
      productOptions: [],
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true

        this.productOptions = []
        this.dialogAddEditViewForm = {
          industry: '',
          brand: '',
          productId: '',
          productName: '',
          minStorageAmount: 0,
          maxStorageAmount: 0,
          minArrivalAmount: 0,
          maxArrivalAmount: 0,
          minPrice: 0,
          maxPrice: 0,
          remark: ''
        }

        if (this.eventType !== 'add') {
          this.loadData()
        } else {
          this.initTobaccoSelectData()
        }
      }
    }
  },
  methods: {
    // 加载数据
    loadData () {
      initRetailMonitoringProductDataRangeApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 初始化品规
    initTobaccoSelectData () {
      listTobaccoInfoApi({ status: 1 }).then(res => {
        if (res.data) {
          res.data.forEach(item => {
            this.productOptions.push({
              data: item.id,
              label: item.name,
              industry: item.industry,
              brand: item.brand
            })
          })
        }
        this.loading = false
      })
    },
    // 选择调查品规回调
    changeProductFun (val) {
      let selectItem = {}
      selectItem = this.productOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.productName = selectItem ? selectItem.label : ''
      this.dialogAddEditViewForm.industry = selectItem ? selectItem.industry : ''
      this.dialogAddEditViewForm.brand = selectItem ? selectItem.brand : ''
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '零售监测调查品规数据范围限制', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true

              saveOrUpdateRetailMonitoringProductDataRangeApi(this.dialogAddEditViewForm).then(res => {
                if (res.mark === '200') {
                  this.$message({ message: res.message, type: 'success' })
                  this.reloadData()
                  this.modalClose()
                }
              }).catch(() => {
                this.loading = false
              })
            })
            .catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
